<div class="alert alert-danger  alertMessageStyles80" role="alert" *ngIf="displayFailure">
    <h5 class="H5Normal" style="display:inline">{{this.failureText}}</h5>
    <h5 class="H5Normal" style="cursor:pointer;display:inline;float:right;" (click)="HideFailureAlert()">X</h5>
</div>
<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="headerImageHeight4" style="background-size: cover; background-position:center;"
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + headerImageToUse + ')'}">
        <div class="row">
            <div style="width:22%"></div>
            <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:56%">
                <h1 *ngIf="defWarehouse.city" class="DINNextLTPro-Black whiteText headerImageTextLarge"
                    style="text-transform: uppercase;">
                    {{defWarehouse.name}}
                    <!-- {{defWarehouse.city}}, {{defWarehouse.state}} -->
                </h1>
                <h1 *ngIf="!defWarehouse.city" class="DINNextLTPro-Black whiteText headerImageTextLarge"
                    style="text-transform: uppercase;">
                    <!-- no location selected yet so set the header to this  -->
                    Our Locations
                </h1>

            </div>
            <div style="width:22%"></div>
        </div>
    </div>
</div>

<!-- desktop  -->
<div class="pt-3" style="padding-bottom:70px"
    *ngIf="!usersLocationdetected && myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">

    <div class="row " style="padding-top:70px;width:1200px;; max-width:1200px; margin:auto;">
        <div class="col-md-6" style="border-right:solid 1px grey">
            <h2 class="Caecilia76BoldItalic"
                style="margin-left:88px;font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                Search By Zip Code</h2>
        </div>
        <div class="col-md-6">
            <h2 class="Caecilia76BoldItalic"
                style="margin-left:122px;font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                Search By Current Location</h2>
        </div>
    </div>
    <div class="row" style="width:1200px; max-width:1200px; margin:auto;">
        <div class="col-md-12 text-center">
            <h2 class="Caecilia76BoldItalic"
                style="font-size: 21px;font-style: normal;font-weight: 700;line-height: 21px;">
                or</h2>
        </div>
    </div>
    <div class="row" style="width:1200px;; max-width:1200px; margin:auto;">
        <div class="col-md-6" style="border-right:solid 1px grey">
            <div class="row d-block">
                <input Class="DIN2014Regular"
                    style="display:inline;font-size:19px;line-height:30px;height:48px;width:254px; margin-left:100px"
                    placeholder="Zip Code" [(ngModel)]="this.zipCode" (keyup.enter)="GetLocationFromZip()">
                <a class="col-lg-4"
                    style="padding:10px;font-size:20px; text-decoration: none !important;text-align:left;cursor: pointer;"
                    (click)="GetLocationFromZip()">
                    <h3 class="DINNextLTPro-Black whiteText blueBackground"
                        style="display:inline;text-align: left;font-size:20px;font-weight:900; padding:12px">SUBMIT</h3>
                </a>
            </div>
        </div>
        <div class="col-md-6">
            <a class="col-lg-4"
                style="margin-top:20px;padding:10px;font-size:20px; text-decoration: none !important;text-align:left;cursor: pointer;"
                (click)="GetDefLocation()">
                <h3 class="DINNextLTPro-Black whiteText blueBackground"
                    style="position:relative; top:5px;margin-left:20%;display:inline;text-align: left;font-size:20px;font-weight:900; padding:12px">
                    USE MY LOCATION
                </h3>
            </a>
        </div>
    </div>
</div>

<!-- mobile -->
<div class="container"
    *ngIf="!usersLocationdetected && myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && (myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
    <div class="row text-center" style="margin-top:50px">
        <div class="col-12">
            <h2 class="Caecilia76BoldItalic"
                style="font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                Search By Zip Code</h2>
        </div>

    </div>
    <div class="row text-center">
        <div class="col-12">
            <input Class="DIN2014Regular" style="display:inline;font-size:19px;line-height:30px;height:48px;width:254px"
                placeholder="Zip Code" [(ngModel)]="this.zipCode" (keyup.enter)="GetLocationFromZip()">
        </div>
    </div>
    <div class="row text-center">
        <div class="col-xs-12" style="text-align: center;margin-top:20px">
            <button class="DINNextLTPro-Black whiteText blueBackground"
                style="border:none; padding: 12px 12px 3px 12px; margin: auto; display: block;"
                (click)="GetLocationFromZip()">
                <h3 style="font-size:20px;font-weight:900;">SUBMIT</h3>
            </button>
        </div>
    </div>

    <div class="row text-center" style="margin-top:50px">
        <div class="col-12">
            <h2 class="Caecilia76BoldItalic"
                style="font-size: 28px;font-style: normal;font-weight: 700;line-height: normal;">
                Search By Current Location</h2>
        </div>

    </div>
    <div class="row text-center">
        <div class="col-xs-12" style="text-align: center;">
            <button class="DINNextLTPro-Black whiteText blueBackground"
                style="border:none; padding: 12px 12px 3px 12px; margin: auto; display: block;"
                (click)="GetDefLocation()">
                <h3 style="font-size:20px;font-weight:900;">USE MY LOCATION</h3>
            </button>
        </div>
    </div>
</div>

<div class="whiteBackground mb-5" id="warehouses" style="text-align: left; margin-left:10%; margin-right:10%;"
    *ngIf="!usersLocationdetected">
    <div class="row mt-5 mb-3">
        <h2 class="Caecilia76BoldItalic greenText" style="font-size:28px; font-weight: 700; ">Our Warehouses</h2>
    </div>
    <!-- expandable warehouse list - grid of ALL warehouses -->
    <div *ngFor="let warehouse of this.warehousesAll" style="border-bottom:solid 1px grey;">
        <div class="row" (click)="ToggleExpandAllWarehouses(warehouse)">
            <h6 class="DIN2014Regular"
                style="text-transform:uppercase; padding-bottom:10px;margin-top:25px;display:inline-block;font-size:21px; line-height:25px; letter-spacing: 0.42px">
                {{warehouse.alt_name}}
                <img *ngIf="this.warehouseToDisplay == warehouse.Id" src="{{this.pageImagePaths + 'up-arrow.png'}}"
                    alt="arrow up" style="cursor:pointer;float:right;margin-top:10px">
                <img *ngIf="this.warehouseToDisplay != warehouse.Id" src="{{this.pageImagePaths + 'down-arrow.png'}}"
                    alt="arrow down" style="cursor:pointer;float:right;margin-top:10px">
            </h6>
        </div>
        <!-- all warehouse info - displays if expanded -->
        <div *ngIf="this.warehouseToDisplay == warehouse.Id">
            <div class="row  mb-5 mt-5">
                <div class="col-md-6">
                    <h6 class="DINNextLTPro-Black" style="font-size:30px; font-weight:900; line-height:36px;">
                        {{warehouse.name}}</h6>
                    <img src="{{this.pageImagePaths + 'location-icon.png'}}" alt="phone icon"
                        style="display:inline-block;cursor:pointer;margin-top:-2px">
                    <h6 class="DIN2014Regular"
                        style="margin-left:5px;display:inline-block;font-size:19px; font-weight:400; line-height:30px;">
                        {{warehouse.address}}</h6>
                    <h6 class="DIN2014Regular"
                        style="margin-left:30px;font-size:19px; font-weight:400; line-height:30px;">
                        {{warehouse.city}}, {{warehouse.state}} {{warehouse.zip}}</h6>
                    <img src="{{this.pageImagePaths + 'call-icon.png'}}" alt="phone icon"
                        style="display:inline-block;cursor:pointer;margin-top:-2px">
                    <h6 class="DIN2014Regular"
                        style="margin-left:5px;display:inline-block;font-size:19px; font-weight:400; line-height:30px;">
                        <a class="telephoneNmbr" href='tel:{{warehouse.phone}}'>{{warehouse.phone}}</a></h6>
                    <h3 style="margin-top:20px"><a class="DINNextLTPro-Black lightBlueBackground blueText"
                            style="cursor:pointer;font-size:20px ;padding-top:6px; padding-bottom:6px; text-decoration: none !important; display: inline-block; width:170px; text-align:center"
                            (click)="GetDirections(warehouse)">GET
                            DIRECTIONS</a>
                    </h3>
                    <h3 style="margin-top:20px; margin-bottom:20px"><a
                            class="DINNextLTPro-Black lightBlueBackground blueText"
                            style="cursor:pointer;font-size:20px ;padding-top:6px; padding-bottom:6px; text-decoration: none !important; display: inline-block; width:170px; text-align:center"
                            (click)="GetLocationFromWhseGraph(warehouse.zip)">MORE INFO</a>
                    </h3>
                </div>
                <div class="col-md-6">
                    <div
                        *ngIf="(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
                        <google-map height="340px"  width="340" [options]="options">
                            <!-- red pin marker goes inside the map tags-->
                            @for (location of nzLocations; track location) {
                            <map-advanced-marker #markerElem="mapAdvancedMarker"
                                [position]="{ lat: location.lat, lng: location.lng }" />
                            }
                            <!-- red pin marker goes inside the map tags-->
                        </google-map>
                    </div>
                    <div
                    *ngIf="!(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
                    <google-map height="340px" width="540px" [options]="options">
                        <!-- red pin marker goes inside the map tags-->
                        @for (location of nzLocations; track location) {
                        <map-advanced-marker #markerElem="mapAdvancedMarker"
                            [position]="{ lat: location.lat, lng: location.lng }" />
                        }
                        <!-- red pin marker goes inside the map tags-->
                    </google-map>
                </div>                    
                </div>
            </div>
            <!-- <div class="row mb-3">
                <h6 class="DINNextLTPro-Black" class="mt-5" style="font-size:30px; font-weight:900; line-height:36px;">
                    {{warehouse.name.replace('Warehouse','Customer Service')}}</h6>
                <div *ngFor="let emp of warehouse.employees" class="col-md-4 pl-0 pr-0">
                    <img src="{{emp.empPhoto}}" alt="emp photo"
                        title="{{emp.FirstName}} {{emp.LastName }} ({{emp.Title}})"
                        style="display:inline-block;cursor:pointer;width:25vw; height:25vw">
                </div>
            </div> -->
        </div>
    </div>
</div>


<!-- search warehouse by list -->
<!-- <div *ngIf="!usersLocationdetected" class="row" style="max-width:990px;margin:auto">
    <div *ngFor="let warehouse of this.dotComService.warehouses" class="col-md-4 whiteBackground">
        <div class="lightCremeBackground" style="padding-left:20px;  height:267px; margin-bottom:30px"
            (click)="GetLocationFromWhseGraph(warehouse.zip)">
            <h6 class="DINNextLTPro-Black pt-3" style="font-size:30px; font-weight:900; line-height:36px;">
                {{warehouse.city}}, {{warehouse.state}}</h6>
            <div class="row">
                <div class="col-1">
                    <img src="{{this.pageImagePaths + 'location-icon.png'}}" alt="location icon"
                        style="display:inline-block;cursor:pointer;margin-top:-2px">
                </div>
                <div class="col-10">
                    <h6 class="DIN2014Regular"
                        style="margin-left:5px;display:inline-block;font-size:19px; font-weight:400; line-height:30px;">
                        {{warehouse.address}}, {{warehouse.city}}, {{warehouse.state}} {{warehouse.zip}}</h6>
                </div>
            </div>
            <div class="row">
                <div class="col-1">
                    <img src="{{this.pageImagePaths + 'call-icon.png'}}" alt="phone icon"
                        style="display:inline-block;cursor:pointer;margin-top:-2px">
                </div>
                <div class="col-10" style="height:43px;">
                    <h6 class="DIN2014Regular"
                        style="margin-left:5px;display:inline-block;font-size:19px; font-weight:400; line-height:30px;">
                        {{warehouse.phone}}</h6>
                </div>
            </div>
            <h3 class="mt-2 pb-4"><a class="DIN2014Bold lightBlueBackground blueText"
                    style="cursor:pointer;font-size:20px ;padding:8pt; text-decoration: none !important"
                    (click)="GetDirections(warehouse)">GET
                    DIRECTIONS</a>
            </h3>
        </div>
    </div>
</div> -->

<div *ngIf="usersLocationdetected" class="row mb-2 " style="width:87%; max-width:1200px; margin:auto;margin-top:70px">
    <div class="col-md-6">
        <!-- <h6 class="DINNextLTPro-Black" style="font-size:30px; font-weight:900; line-height:36px;">
            {{defWarehouse.name}}</h6> -->
        <img src="{{this.pageImagePaths + 'location-icon.png'}}" alt="phone icon"
            style="display:inline-block;cursor:pointer;margin-top:-2px">
        <h6 class="DIN2014Regular"
            style="margin-left:5px;display:inline-block;font-size:19px; font-weight:400; line-height:30px;">
            {{defWarehouse.address}}</h6>
        <h6 class="DIN2014Regular" style="margin-left:30px;font-size:19px; font-weight:400; line-height:30px;">
            {{defWarehouse.city}}, {{defWarehouse.state}} {{defWarehouse.zip}}</h6>
        <img src="{{this.pageImagePaths + 'call-icon.png'}}" alt="phone icon"
            style="display:inline-block;cursor:pointer;margin-top:-2px">
        <h6 class="DIN2014Regular"
            style="margin-left:5px;display:inline-block;font-size:19px; font-weight:400; line-height:30px;">
            <a class="telephoneNmbr" href='tel:{{defWarehouse.phone}}'>{{defWarehouse.phone}}</a></h6>
        <h3 style="margin-top:20px; margin-bottom:20px"><a class="DIN2014Bold greenBackground whiteText"
                style="cursor:pointer;font-size:20px ;padding:6px 22px; text-decoration: none !important"
                (click)="GetDirections(defWarehouse)">GET
                DIRECTIONS</a>
        </h3>
    </div>
    <div class="col-md-6" style="margin-bottom:70px">
        <div
        *ngIf="(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
        <google-map height="340px" width="340" [options]="optionsDefMap">
            <!-- red pin marker goes inside the map tags-->
            @for (location of defMarker; track location) {
            <map-advanced-marker #markerElem="mapAdvancedMarker"
                [position]="{ lat: location.lat, lng: location.lng }" />
            }
            <!-- red pin marker goes inside the map tags-->
        </google-map>
        </div>
        <div
        *ngIf="!(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
        <google-map height="340px" width="100%" [options]="optionsDefMap">
            <!-- red pin marker goes inside the map tags-->
            @for (location of defMarker; track location) {
            <map-advanced-marker #markerElem="mapAdvancedMarker"
                [position]="{ lat: location.lat, lng: location.lng }" />
            }
            <!-- red pin marker goes inside the map tags-->
        </google-map>
        </div>
    </div>

    <!-- <div class="row mt-3 mb-2" *ngIf="haveDefLocationImages" style="padding:0px">
        <div class="col-md-4" style="padding:0px">
            <img src="{{this.pageImagePaths + defWarehouse.city + '-Left.jpg'}}" alt="left loc image"
                style="display:inline-block;cursor:pointer;margin-top:-2px; object-fit: cover;object-position: center;max-width: 100%;max-height: 100%;min-width: 100%;min-height: 100%;">
        </div>
        <div class="col-md-4" style="padding:0px">
            <img src="{{this.pageImagePaths + defWarehouse.city + '-Main.jpg'}}" alt="main loc image"
                style="display:inline-block;cursor:pointer;margin-top:-2px; object-fit: cover;object-position: center;max-width: 100%;max-height: 100%;min-width: 100%;min-height: 100%;">
        </div>
        <div class="col-md-4" style="padding:0px">
            <img src="{{this.pageImagePaths + defWarehouse.city + '-Right.jpg'}}" alt="right loc image"
                style="display:inline-block;cursor:pointer;margin-top:-2px; object-fit: cover;object-position: center;max-width: 100%;max-height: 100%;min-width: 100%;min-height: 100%;">
        </div>
    </div> -->
    <div class="row mt-3 mb-2" *ngIf="haveDefLocationImages" style="padding:0px;margin-right:0px;margin-left:0px">
        <div style="padding:0px;  margin:auto">
            <img src="{{this.pageImagePaths + defWarehouse.city + '-Left.jpg'}}" alt="left loc image"
                class="warehouseImageLeft">

            <img src="{{this.pageImagePaths + defWarehouse.city + '-Right.jpg'}}" alt="right loc image"
                class="warehouseImageRight">
        </div>
    </div>

</div>

<div *ngIf="usersLocationdetected" class="whiteBackground mb-5" style="width:87%; max-width:1200px;margin:auto">
    <div class="row mb-3" style="margin-top:70px;text-align: left;">
        <div class="col-6">
            <h2 class="Caecilia76BoldItalic greenText" style="font-size:28px; font-weight: 700; ">Nearby Locations</h2>
        </div>

        <div class="col-6 text-end">
            <h4 class="DIN2014Bold blackText"
                style="cursor:pointer; font-size:16px; font-weight:700; text-decoration: none !important"
                (click)="ViewAllWarehouses()">VIEW ALL WAREHOUSES</h4>
        </div>
    </div>
    <!-- expandable warehouse list - grid of CLOSEST 3 WAREHOUSES warehouses TO THE SELECTED WAREHOUSE-->
    <div *ngFor="let warehouse of this.warehousesInDistanceOrder" style="border-bottom:solid 1px grey;">
        <div class="row" (click)="ToggleExpand(warehouse.warehouse)">
            <h6 class="DIN2014Regular"
                style="text-transform:uppercase; padding-bottom:10px;margin-top:25px;display:inline-block;font-size:21px; line-height:25px; letter-spacing: 0.42px">
                <!-- {{warehouse.warehouse.alt_name}} -->
                {{warehouse.warehouse.city}}, {{warehouse.warehouse.state}}
                <img *ngIf="this.warehouseToDisplay == warehouse.warehouse.Id"
                    src="{{this.pageImagePaths + 'up-arrow.png'}}" alt="arrow up"
                    style="cursor:pointer;float:right;margin-top:10px">
                <img *ngIf="this.warehouseToDisplay != warehouse.warehouse.Id"
                    src="{{this.pageImagePaths + 'down-arrow.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
            </h6>
        </div>
        <!-- warehouse info - displays if expanded -->
        <div *ngIf="this.warehouseToDisplay == warehouse.warehouse.Id">
            <div class="row mb-5 mt-5">
                <div class="col-md-6">
                    <h6 class="DINNextLTPro-Black" style="font-size:30px; font-weight:900; line-height:36px;">
                        {{warehouse.warehouse.name}}</h6>
                    <img src="{{this.pageImagePaths + 'location-icon.png'}}" alt="phone icon"
                        style="display:inline-block;cursor:pointer;margin-top:-2px">
                    <h6 class="DIN2014Regular"
                        style="margin-left:5px;display:inline-block;font-size:19px; font-weight:400; line-height:30px;">
                        {{warehouse.warehouse.address}}</h6>
                    <h6 class="DIN2014Regular"
                        style="margin-left:30px;font-size:19px; font-weight:400; line-height:30px;">
                        {{warehouse.warehouse.city}}, {{warehouse.warehouse.state}} {{warehouse.warehouse.zip}}</h6>
                    <img src="{{this.pageImagePaths + 'call-icon.png'}}" alt="phone icon"
                        style="display:inline-block;cursor:pointer;margin-top:-2px">
                    <h6 class="DIN2014Regular"
                        style="margin-left:5px;display:inline-block;font-size:19px; font-weight:400; line-height:30px;">
                        <a class="telephoneNmbr" href='tel:{{warehouse.warehouse.phone}}'>{{warehouse.warehouse.phone}}</a></h6>
                    <h3 style="margin-top:20px"><a class="DINNextLTPro-Black lightBlueBackground blueText"
                            style="cursor:pointer;font-size:20px ;padding-top:6px; padding-bottom:6px;; text-decoration: none !important; display: inline-block; width:170px; text-align:center"
                            (click)="GetDirections(warehouse.warehouse)">GET
                            DIRECTIONS</a>
                    </h3>
                    <h3 style="margin-top:20px; margin-bottom:20px"><a
                            class="DINNextLTPro-Black lightBlueBackground blueText"
                            style="cursor:pointer;font-size:20px ;padding-top:6px; padding-bottom:6px; text-decoration: none !important; display: inline-block; width:170px; text-align:center"
                            (click)="GetLocationFromWhseGraph(warehouse.warehouse.zip)">MORE INFO</a>
                    </h3>
                </div>
                <div class="col-md-6">
                    <div
                        *ngIf="(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
                        <google-map height="340px"  width="340" [options]="options">
                            <!-- red pin marker goes inside the map tags-->
                            @for (location of altLocationsMarkers; track location) {
                            <map-advanced-marker #markerElem="mapAdvancedMarker"
                                [position]="{ lat: location.lat, lng: location.lng }" />
                            }
                            <!-- red pin marker goes inside the map tags-->
                        </google-map>
                    </div>
                    <div
                        *ngIf="!(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
                        <google-map height="340px" width="540px" [options]="options">
                            <!-- red pin marker goes inside the map tags-->
                            @for (location of altLocationsMarkers; track location) {
                            <map-advanced-marker #markerElem="mapAdvancedMarker"
                                [position]="{ lat: location.lat, lng: location.lng }" />
                            }
                            <!-- red pin marker goes inside the map tags-->
                        </google-map>
                    </div>
                </div>
            </div>

            <!-- <div class="row mt-3 mb-2" *ngIf="haveAltLocationImages" style="padding:0px">
                <div class="col-md-4" style="padding:0px">
                    <img src="{{this.pageImagePaths + warehouse.warehouse.city + '-Left.jpg'}}" alt="left loc image"
                        style="display:inline-block;cursor:pointer;margin-top:-2px; object-fit: cover;object-position: center;max-width: 100%;max-height: 100%;min-width: 100%;min-height: 100%;">
                </div>
                <div class="col-md-4" style="padding:0px">
                    <img src="{{this.pageImagePaths + warehouse.warehouse.city + '-Main.jpg'}}" alt="main loc image"
                        style="display:inline-block;cursor:pointer;margin-top:-2px; object-fit: cover;object-position: center;max-width: 100%;max-height: 100%;min-width: 100%;min-height: 100%;">
                </div>
                <div class="col-md-4" style="padding:0px">
                    <img src="{{this.pageImagePaths + warehouse.warehouse.city + '-Right.jpg'}}" alt="right loc image"
                        style="display:inline-block;cursor:pointer;margin-top:-2px; object-fit: cover;object-position: center;max-width: 100%;max-height: 100%;min-width: 100%;min-height: 100%;">
                </div>
            </div> -->

        </div>
    </div>
</div>

<!-- <div class="lightCremeBackground pb-3" style="padding-top:80px">
    <div class="row text-center" style="width:90%; max-width: 1600px; margin:auto">
        <h2 class="Caecilia76BoldItalic greenText" style="font-size:28px; font-weight: 700; margin-bottom:25px ">
            Product Categories To
            Explore</h2>
        <div class="row">
            <div class="col-md-6">
                <a href="/golf" style="text-decoration: none;">
                    <img src="{{this.pageImagePaths + 'golf.png'}}" alt="ag image"
                        style="display:inline-block;cursor:pointer;margin-top:-2px; width:100%">
                    <h4 class="whiteText DIN2014Regular"
                        style="position:relative; top:-50px; font-size: 26px; font-weight: 700;">Golf Courses</h4>
                </a>
            </div>
            <div class="col-md-6">
                <a href="/lawn" style="text-decoration: none;">
                    <img src="{{this.pageImagePaths + 'lawn.png'}}" alt="golf image"
                        style="display:inline-block;cursor:pointer;margin-top:-2px; width:100%">
                    <h4 class="whiteText DIN2014Regular"
                        style="position:relative; top:-50px; font-size: 26px; font-weight: 700;">Lawn + Landscape
                    </h4>
                </a>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <a href="/horticulture" style="text-decoration: none;">
                    <img src="{{this.pageImagePaths + 'hort.png'}}" alt="horticulture image"
                        style="display:inline-block;cursor:pointer;margin-top:-2px; width:100%">
                    <h4 class="whiteText DIN2014Regular"
                        style="position:relative; top:-50px; font-size: 26px; font-weight: 700;">Horticulture</h4>
                </a>
            </div>
            <div class="col-md-6">
                <a href="/specialty" style="text-decoration: none;">
                    <img src="{{this.pageImagePaths + 'ag.png'}}" alt="ag image"
                        style="display:inline-block;cursor:pointer;margin-top:-2px; width:100%">
                    <h4 class="whiteText DIN2014Regular"
                        style="position:relative; top:-50px; font-size: 26px; font-weight: 700;">Specialty Ag</h4>
                </a>
            </div>
        </div>
    </div>
</div> -->
<div class="blueBackground pt-5 pb-5">
    <div class="row" style="width:90%; max-width: 1600px; margin:auto">
        <div class="col-md-6">
            <h2 class="Caecilia76BoldItalic whiteText" style="font-size: 28px; font-weight: 700; line-height: 36px;">
                Our entire team is here to support you.</h2>
        </div>
        <div class="col-md-6 ">
            <h3 class="locationsConnectBtn"><a class="DIN2014Bold whiteBackground greenText"
                    style="font-size:20PX ;padding:8pt; text-decoration: none !important" href='/contact'>CONNECT
                    WITH
                    CORPORATE</a>
            </h3>
        </div>
    </div>
</div>